import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL


class Authentication {
  login(data) {
    return axios.post(BASE_URL + "/admin/auth/loginUser", data)
  }

  verifyLogin(data) {
    return axios.post(BASE_URL + "/admin/auth/verifyOtp", data)
  }

  getUserDetailsById(config) {
    return axios.get(BASE_URL + "/admin/auth/getUserDetailById", config)
  }

  getAnalyst(config) {
    return axios.get(BASE_URL + "/admin/auth/getAnalystusers", config)
  }
  getPortalUserById(data, config) {
    return axios.get(BASE_URL + "/admin/auth/getUserById/" + data, config)
  }
  createUser(data, config) {
    return axios.post(BASE_URL + "/admin/auth/createUser", data, config)
  }
  forgotPassword(data, config) {
    return axios.post(BASE_URL + "/admin/auth/forgotPassword", data, config)
  }
  verifyForgotOtp(data, config) {
    return axios.post(BASE_URL + "/admin/auth/verifyForgotOtp", data, config)
  }
  resetPassword(data, config) {
    return axios.post(BASE_URL + "/admin/auth/resetPassword", data, config)
  }
  changePassword(data, config) {
    return axios.post(BASE_URL + "/admin/auth/changePassword", data, config)
  }
  getAllUsers(config) {
    return axios.get(BASE_URL + "/admin/applicationUser/getAllUsers", config)
  }
  getTeenUsers(config) {
    return axios.get(BASE_URL + "/admin/applicationUser/getTeenUsers", config)
  }
  getUserById(data, config) {
    return axios.get(
      BASE_URL + "/admin/applicationUser/getUserById/" + data,
      config,
    )
  }

  updateRole(data, config) {
    return axios.put(BASE_URL + "/admin/auth/updateRole", data, config)
  }

  changeUsername(data, config) {
    return axios.put(BASE_URL + "/admin/auth/changeUserName", data, config)
  }
  generateDeleteUserOtp(userId, config) {
    return axios.post(
      `${BASE_URL}/admin/auth/generateDeleteUserOtp/${userId}`,
      {}, // empty body since we're sending userId in params
      config,
    )
  }

  // Update the deletePortalUser method
  deletePortalUser(userId, data, config) {
    return axios.delete(`${BASE_URL}/admin/auth/deleteUser/${userId}`, {
      ...config,
      data: {
        otp: data.otp,
        deletedReason: data.deletedReason,
      },
    })
  }
  getUserPostFeed(userId, config) {
    return axios.get(
      `${BASE_URL}/admin/applicationUser/getUserGab/${userId}`,
      config,
    )
  }
  UserLockAndUnlock(userId, data, config) {
    return axios.post(
      `${BASE_URL}/admin/applicationUser/lockAndUnlockUser/${userId}`,
      data,
      config,
    )
  }

  UserVerification(userId, config) {
    return axios.post(
      `${BASE_URL}/admin/applicationUser/resendRegistrationOtp/${userId}`,
      null,
      config,
    )
  }

  deleteGabOtpConfirmation(payload, config) {
    return axios.post(
      `${BASE_URL}/admin/applicationUser/deleteConfirmation`,
      payload,
      config,
    )
  }

  confirmDeleteGab(gabId, payload, config) {
    return axios.post(
      `${BASE_URL}/admin/applicationUser/deleteGab/${gabId}`,
      payload,
      config,
    )
  }

  deleteComment(payload, config) {
    return axios.post(
      `${BASE_URL}/admin/applicationUser/deleteComment`,
      payload,
      config,
    )
  }
  deleteUser(userId, payload, config) {
    return axios.post(
      `${BASE_URL}/admin/applicationUser/deleteUser/${userId}`,
      payload,
      config,
    )
  }

  resetUserPassword(userId, data, config) {
    return axios.post(
      `${BASE_URL}/admin/applicationUser/resetUserPassword/${userId}`,
      data,
      config,
    )
  }


  deleteParent(userId, config) {
    return axios.delete(`${BASE_URL}/admin/applicationUser/deleteParent/${userId}`, config)
  }

  deleteParentFromStudent(studentId, parentId, config) {
    return axios.delete(`${BASE_URL}/admin/applicationUser/deleteParentFromStudent/${studentId}/${parentId}`, config)
  }
}

const authenticationApi = new Authentication();
export default authenticationApi;
